// src/components/Gallery/Gallery.js

import React, { useEffect, useState, useCallback } from 'react';
import axios from '../api/axios';
import './Gallery.css';

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [modalIndex, setModalIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  const BASE_URL = 'https://blog.dietchapter.hosting.acm.org/'; 
  
  // Use useCallback to memoize navigation functions for useEffect dependency array
  const closeModal = useCallback(() => setModalIndex(null), []);
  const showPrev = useCallback(() => {
    setModalIndex(prev => (prev > 0 ? prev - 1 : images.length - 1)); // Wrap around
  }, [images.length]);
  const showNext = useCallback(() => {
    setModalIndex(prev => (prev < images.length - 1 ? prev + 1 : 0)); // Wrap around
  }, [images.length]);
  
  const openModal = (index) => setModalIndex(index);
  
  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    setLoading(true);
    try {
      // Backend should already return images sorted NEWEST FIRST (DESC)
      const res = await axios.get('/gallery'); 
      setImages(res.data);
    } catch (err) {
      console.error('Error fetching gallery:', err);
    } finally {
      setLoading(false);
    }
  };

  // Preserve keyboard navigation logic
  useEffect(() => {
    const handleKey = (e) => {
      if (modalIndex === null) return;
      if (e.key === 'ArrowLeft') showPrev();
      else if (e.key === 'ArrowRight') showNext();
      else if (e.key === 'Escape') closeModal();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [modalIndex, showPrev, showNext, closeModal]);


  if (loading) {
    return <div className="gallery-container loading-page">Loading memories...</div>;
  }
  
  if (images.length === 0) {
      return <div className="gallery-container no-images">No memories uploaded yet.</div>;
  }

  const currentImage = modalIndex !== null ? images[modalIndex] : null;

  return (
    <section id="gallery" className="gallery-container">
      <div className="gallery-header">
        <h2 className="gallery-title">GALLERY</h2>
        <p className="gallery-subtitle">
          A journey through the memories of DIET ACM Student Chapter—where learning, 
          ideas, innovation, creativity flourishes, and lifelong bonds are forged.
        </p>
      </div>

      <div className="gallery-grid">
        {images.map((img, index) => (
          <div key={img.id} className="gallery-item" onClick={() => openModal(index)}>
            <img
              src={`${BASE_URL}/${img.imagePath.replace(/\\/g, "/")}`}
              alt={`Event ${index + 1}`}
              className="gallery-image"
            />
          </div>
        ))}
      </div>
      
      {/* Load More Button (Static for display matching) */}
      <div className="load-more-section">
          <button className="load-more-btn">
              <i className="fas fa-camera"></i> Load More Memories
          </button>
      </div>


      {/* --- Modal Overlay (Preserved Logic) --- */}
      {modalIndex !== null && currentImage && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close" onClick={closeModal}>&times;</span>
            <img
              src={`${BASE_URL}/${currentImage.imagePath.replace(/\\/g, "/")}`}
              alt={`Event ${modalIndex + 1}`}
              className="modal-image"
            />
            {/* Prev/Next Buttons, wrap-around logic is in showPrev/showNext */}
            <button className="arrow left-arrow" onClick={showPrev}>&#8592;</button>
            <button className="arrow right-arrow" onClick={showNext}>&#8594;</button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;